/*
  Velnuit · Sections modulables — comportements légers (sans dépendance).
  - <vn-livraison> : dates de livraison estimées + compte à rebours jusqu'à l'heure limite d'expédition.
  - <vn-barre-achat> : affiche la barre d'achat collante après un certain défilement.
  Chargé en « defer » par chaque section : la garde customElements.get évite les doubles définitions.
*/
(function () {
  if (!customElements.get('vn-livraison')) {
    class VnLivraison extends HTMLElement {
      connectedCallback() {
        this.min = parseInt(this.dataset.min || '3', 10);
        this.max = parseInt(this.dataset.max || '5', 10);
        this.limite = parseInt(this.dataset.limite || '-1', 10);
        this.weekend = this.dataset.weekend === 'true';
        this.locale = this.dataset.locale || document.documentElement.lang || 'fr';
        this.dates = this.querySelector('[data-dates]');
        this.compte = this.querySelector('[data-compte]');
        this.reste = this.querySelector('[data-reste]');
        this.maj();
        this.minuteur = setInterval(() => this.maj(), 30000);
      }
      disconnectedCallback() { clearInterval(this.minuteur); }
      ajouterJours(depart, n) {
        const d = new Date(depart);
        let ajoutes = 0;
        while (ajoutes < n) {
          d.setDate(d.getDate() + 1);
          const j = d.getDay();
          if (this.weekend || (j !== 0 && j !== 6)) ajoutes++;
        }
        return d;
      }
      maj() {
        const maintenant = new Date();
        let depart = new Date(maintenant);
        const apresLimite = this.limite >= 0 && maintenant.getHours() >= this.limite;
        if (apresLimite) depart.setDate(depart.getDate() + 1);
        const fmt = new Intl.DateTimeFormat(this.locale, { weekday: 'short', day: 'numeric', month: 'short' });
        const a = this.ajouterJours(depart, this.min);
        const b = this.ajouterJours(depart, this.max);
        if (this.dates) {
          this.dates.textContent = this.min === this.max ? fmt.format(a) : fmt.format(a) + ' – ' + fmt.format(b);
        }
        if (this.compte && this.reste && this.limite >= 0) {
          const cible = new Date(maintenant);
          cible.setHours(this.limite, 0, 0, 0);
          if (apresLimite) cible.setDate(cible.getDate() + 1);
          const minutes = Math.max(0, Math.round((cible - maintenant) / 60000));
          const h = Math.floor(minutes / 60);
          const m = minutes % 60;
          this.reste.textContent = h + ' h ' + String(m).padStart(2, '0') + ' min';
          this.compte.hidden = false;
        }
      }
    }
    customElements.define('vn-livraison', VnLivraison);
  }

  if (!customElements.get('vn-barre-achat')) {
    class VnBarreAchat extends HTMLElement {
      connectedCallback() {
        this.seuil = parseInt(this.dataset.seuil || '0', 10);
        this.barre = this.querySelector('.vnm-barre');
        if (!this.barre) return;
        this.surDefilement = () => {
          const cachee = window.scrollY < this.seuil;
          this.barre.dataset.cachee = String(cachee);
          this.barre.toggleAttribute('inert', cachee);
        };
        window.addEventListener('scroll', this.surDefilement, { passive: true });
        this.surDefilement();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.surDefilement);
      }
    }
    customElements.define('vn-barre-achat', VnBarreAchat);
  }
})();
